export default __webpack_public_path__ + "static/media/client6.dec0afc2.png";